import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getTranslation } from '../utils/translations';
import { SvgIcon } from './SvgIcon';

export const FilterButton = ({ onChange }) => {
    const [areFilterOptionsVisible, setAreFilterOptionsVisible] =
        useState(false);

    useEffect(() => {
        onChange(areFilterOptionsVisible);
    }, [areFilterOptionsVisible]);

    return (
        <button
            className={classNames('filter-button', {
                'filter-button--active': areFilterOptionsVisible
            })}
            onClick={() => {
                setAreFilterOptionsVisible((prev) => !prev);
            }}
        >
            <SvgIcon
                icon="filter-circle"
                className="filter-button__icon"
                folder="elements"
                subfolder="stats"
            />
            <SvgIcon
                icon="filter-circle-fill"
                className="filter-button__icon-active"
                folder="elements"
                subfolder="stats"
            />
            {getTranslation('label.statsLeaders.filters.toggleButtonText')}
        </button>
    );
};

FilterButton.propTypes = {
    onChange: PropTypes.func.isRequired
};
